import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-anulacion-zona-azul-auto-filter',
  templateUrl: './anulacion-zona-azul-auto-filter.component.html',
  styleUrls: ['./anulacion-zona-azul-auto-filter.component.scss']
})
export class AnulacionZonaAzulAutoFilterComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
